export default __webpack_public_path__ + "static/art-blocks-curated-48f1b5771174a11154960dda025ccf54.png";